import { Link } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function productImage(image) {
  if (!image) return null;
  return image.startsWith("http") ? image : `${BACKEND}${image}`;
}

export function ProductBox({ product }) {
  return (
    <Link
      to={`/produkt/${product.id}`}
      className="group block"
      data-testid={`product-card-${product.id}`}
    >
      <div className="aspect-[3/4] overflow-hidden border border-white/10 bg-wine2">
        {productImage(product.image) ? (
          <img
            src={productImage(product.image)}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-sm font-light text-cream/30">
            Kein Bild
          </div>
        )}
      </div>
      <div className="mt-3 flex items-baseline justify-between gap-3">
        <h3 className="truncate font-serif text-lg text-cream">{product.name}</h3>
        <span
          className="shrink-0 text-sm font-medium tracking-wide text-gold"
          data-testid={`product-price-${product.id}`}
        >
          {product.price}
        </span>
      </div>
      <p className="mt-1 text-[0.65rem] font-light uppercase tracking-[0.25em] text-cream/40 transition-colors duration-300 group-hover:text-gold">
        Ansehen →
      </p>
    </Link>
  );
}

export default function ProductGrid({ items, emptyHint, testidPrefix }) {
  if (!items?.length) {
    return (
      <div
        className="border border-dashed border-gold/30 bg-wine2/40 px-6 py-16 text-center"
        data-testid={`${testidPrefix}-empty`}
      >
        <p className="font-serif text-xl text-cream/70">Bald verfügbar</p>
        <p className="mt-2 text-sm font-light text-cream/50">{emptyHint}</p>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4" data-testid={`${testidPrefix}-grid`}>
      {items.map((p) => (
        <ProductBox key={p.id} product={p} />
      ))}
    </div>
  );
}
